import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { CustomerStockItem } from '../models';
import { AbstractApiService } from '../../shared/services';
import { getUriWithPageAndParams } from '../../shared/utilities/urlParams.utility';
import { AbstractApiResponse } from '../../shared/models';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable()
export class CustomerStockItemsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  createCustomerStockItem(
    payload: CustomerStockItem
  ): Observable<CustomerStockItem> {
    return this.rolesService.userHasRoleFilter<CustomerStockItem>(
      'ROLE_MWS_CUSTOMER_STOCK_ITEM_CREATE',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.createObject(`/customer_stock_items`, payload)
    );
  }

  getCustomerStockItem(iri: string): Observable<CustomerStockItem> {
    return this.rolesService.userHasRoleFilter<CustomerStockItem>(
      'ROLE_MWS_CUSTOMER_STOCK_ITEM_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  getCustomerStockItems(
    page: number,
    params: any
  ): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<CustomerStockItem>(
      'ROLE_MWS_CUSTOMER_STOCK_ITEM_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject(
              getUriWithPageAndParams('/customer_stock_items', page, params)
            )
    );
  }

  updateCustomerStockItem(
    iri: string,
    payload: CustomerStockItem
  ): Observable<CustomerStockItem> {
    return this.rolesService.userHasRoleFilter<CustomerStockItem>(
      'ROLE_MWS_CUSTOMER_STOCK_ITEM_EDIT',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.updateObject(iri, payload, true)
    );
  }

  deleteCustomerStockItem(iri: string): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_CUSTOMER_STOCK_ITEM_DELETE',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.deleteObject(iri, true)
    );
  }
}
